import React from 'react'
import { SideBar, TopBar } from '../components'
import { useAuthentication } from '../../application/hooks';

function DashboardLayout({children}) {

  useAuthentication();

  return (
    <div className=" flex w-full h-screen">

      <div className="desktopSidebar shadow-lg w-1/6 hidden md:block">
        <SideBar/>
      </div>

      <div className="dashboard-content flex-1 flex flex-col">

        <div className="dashboard-top-bar">
          <TopBar/>
        </div>

        <div className="dashboard-main-content flex-1 overflow-y-auto p-6">
          {children}
        </div>

      </div>

      <div className=" mobileSidebar hidden">

      </div>


    </div>
  )
}

export default DashboardLayout